<template>
    <div
        id="loading-wrapper"
        :class="{
            'background-vw': brand === 'vw',
            'background-audi': brand === 'audi',
            'background-seat': brand === 'seat',
            'background-porsche': brand === 'porsche',
        }"
    >
        <div
            id="loading-logo"
            :class="{
                'logo-vw': brand === 'vw',
                'logo-audi': brand === 'audi',
                'logo-seat': brand === 'seat',
                'logo-porsche': brand === 'porsche',
            }"
        ></div>
        <div id="loading-content"></div>
    </div>
</template>

<script lang="ts">
import { onBeforeMount, defineComponent, ref, onMounted } from "vue";
import { useRouter } from "vue-router";
import { useLoginStore } from "../stores/login/loginStore";
export default defineComponent({
    name: "Redirect",
    setup() {
        const state = useLoginStore();
        const router = useRouter();
        const brand = ref();

        onBeforeMount(() => {
            brand.value = import.meta.env.VITE_BRAND;
        });

        onMounted(() => {
            setTimeout(() => {
                router.push("/home");
            }, 1000);
        });

        return {
            brand,
            state,
        };
    },
});
</script>

<style scoped>
/**
* Loader
*/
#loading-wrapper {
    position: relative;
    width: 100%;
    height: inherit;
    left: 0;
    top: 0;
    z-index: 9;
}
.background-vw {
    background: #001e50;
}
.background-audi {
    background: #000000 !important;
}
.background-seat {
    background: #000000;
}
.background-porsche {
    background: #000000;
}

#loading-logo {
    display: block;
    position: absolute;
    top: 40%;
    left: 50%;
    color: white;
    width: 100px;
    height: 63px;
    margin: 55px 0 0 -45px;
    text-align: center;
    font-family: "VW-Head";
    font-size: 20px;
    z-index: 1;
}

.logo-vw {
    background: url("@/assets/svg/logo-vw.svg") center no-repeat;
    background-size: 60px 60px;
}

.logo-audi {
    background: url("@/assets/svg/logo-audi.svg") center no-repeat;
    background-size: 100px 60px;
}

.logo-seat {
    background: url("@/assets/svg/logo-seat.svg") center no-repeat;
    background-size: 100px 60px;
}
.logo-porsche {
    background: url("@/assets/svg/logo-porsche.svg") center no-repeat;
    background-size: 100px 60px;
}

#loading-content {
    display: block;
    position: relative;
    top: 40%;
    left: 50%;
    width: 170px;
    height: 170px;
    margin: -80px 10px 0 -80px;
    border: 6px solid;
}

#loading-content {
    border: 6px solid transparent;
    border-top-color: rgb(251, 251, 251);
    border-bottom-color: rgb(255, 255, 255);
    border-radius: 50%;
    -webkit-animation: loader 2s linear infinite;
    -moz-animation: loader 2s linear infinite;
    -o-animation: loader 2s linear infinite;
    animation: loader 2s linear infinite;
}

@keyframes loader {
    0% {
        -webkit-transform: rotate(0deg);
        -ms-transform: rotate(0deg);
        transform: rotate(0deg);
    }

    100% {
        -webkit-transform: rotate(360deg);
        -ms-transform: rotate(360deg);
        transform: rotate(360deg);
    }
}
</style>
